import { BaseModel } from 'app/core/models/base.model';
import { MultimediaCDN } from './multimediaCDN';

export class Media extends BaseModel {
	dtype: string;
	name: string;
	description: string;
	multimediaCDN = new MultimediaCDN();
}
